import { css } from "@emotion/react";
import styled from "@emotion/styled";

export const StatusContainer = styled.div`
  height: 100vh;
  width: 100vw;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${({ theme }) => theme.colors.grey[6]};
`

export const StatusContent = styled.main`
  flex-grow: 0;
  width: 351px;
  display: flex;
  flex-direction: column;
  align-items: center;
`

export const StatusTitle = styled.h1`
  color: ${({ theme }) => theme.colors.neutrals.b};
  ${({ theme }) => css({ ...theme.typographys.xl.bold })};
  margin: 0 0 8px 0;
  text-align: center;
`

export const StatusMessage = styled.p`
  color: ${({ theme }) => theme.colors.grey[5]};
  ${({ theme }) => css({ ...theme.typographys.base.regular })};
  text-align: center;
  margin: 0;
`